var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWeightingScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.858,
    height: 23.858
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".weighting-scale_svg__b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h23.858v23.858H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "weighting-scale_svg__b",
    d: "M11.929 2.982v4.444M14.166 14.722h7.65M2.038 16.959h7.65M14.368 14.194a1.942 1.942 0 00-.214 1.286 3.915 3.915 0 007.682 0 1.942 1.942 0 00-.214-1.286l-3.626-6.738-3.628 6.738zM2.234 16.43a1.942 1.942 0 00-.214 1.286 3.915 3.915 0 007.683 0 1.942 1.942 0 00-.215-1.286L5.862 9.692 2.234 16.43z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "weighting-scale_svg__b",
    d: "M17.996 7.457A17.238 17.238 0 006.53 9.322l-.668.37"
  })));
}

export default SvgWeightingScale;


//////////////////
// WEBPACK FOOTER
// ./src/icons/weighting-scale.svg
// module id = 464
// module chunks = 101